<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->
    <!-- <app-banner-profile
      [image]="img1"
      [title]="title1"
      [customClasses]="class1"
    ></app-banner-profile> -->
    <div class="write-article-page">
      <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title"></h1>
        </div>
        <div class="btnGrpp">
          <button class="gredientOutLineBtn">
            <div class="btnContent">
              + New FAQ
              <img src="./assets/images/edit-line.svg" alt="edit" />
            </div>
          </button>
        </div>
      </div>
      <form>
        <div class="innerpageContent">
          <div class="row">
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">FAQ Category</mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">FAQ SUB Category </mat-label>
                  <mat-select formControlName="eduQualification">
                    <mat-option>test1</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="inputGroup">
                <input
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="Article-title"
                  class="inputBox"
                  id="question"
                  placeholder=""
                />
                <label for="question" class="inputLabel">Question</label>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="inputGroup">
                <textarea
                  onkeydown="return /[a-z ]/i.test(event.key)"
                  type="text"
                  formControlName="Article-title"
                  class="inputBox article-text"
                  id="answer"
                  rows="12"
                  placeholder=""
                >
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae adipisci culpa dolorum itaque. Voluptas, aut! Quis dicta, voluptates commodi velit qui amet veniam incidunt esse atque voluptatum placeat facilis rerum sed laboriosam id, pariatur adipisci provident deserunt ut perferendis explicabo totam. Reiciendis accusamus assumenda ducimus fugiat perferendis dolorum at dignissimos reprehenderit labore fugit modi quis voluptatem doloremque suscipit ab rem, sint iure dolorem. Quas ex minus suscipit, molestiae repellendus officiis! Similique, suscipit deserunt quis, maiores nobis commodi ea mollitia aspernatur delectus vel earum, veniam dicta reprehenderit? Provident similique iste inventore omnis? Et, earum esse saepe cum omnis incidunt fugit quaerat? Pariatur minima distinctio dolores eius eum voluptatibus cumque unde, esse maxime architecto quas commodi suscipit hic, neque voluptatem molestias recusandae beatae ex porro rerum! Beatae similique sunt magni incidunt autem, placeat laudantium, cupiditate, eaque fugit iste praesentium laboriosam blanditiis. Ratione enim repellat provident ducimus quibusdam consequuntur voluptates itaque labore</textarea
                >
                <label for="answer" class="inputLabel">Answer</label>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btnbx mt-5">
            <button type="button" class="btnThemeOutline blue me-3">
              Cancel
            </button>
            <button class="btnTheme red" type="submit">Save</button>
          </div>
        </div>
      </form>
      <app-main-heading [title]="title3"></app-main-heading>
      <div class="admin-table">
        <table class="adminPanel-table">
          <tr>
            <th colspan="2">Question</th>
            <th>FAQ Category</th>
            <th>FAQ SUB Category</th>
            <th>View</th>
            <th>added Date</th>
            <th>ACTIONS</th>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="serielNo">1</td>
            <td>Question 1</td>
            <td>Sub Category 1</td>
            <td>Product</td>
            <td>
              <div class="action-edit">
                <img src="../../../assets/images/eye-line.svg" alt="" />
              </div>
            </td>
            <td>24/10/2023</td>
            <td>
              <div class="actions">
                <div class="action-edit">
                  <img src="../../../assets/images/edit-icon.svg" alt="" />
                </div>
                <div class="action-del">
                  <img src="../../../assets/images/trash-icon.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
